/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Infinite_ScrollInputs */

const en_infinite_scroll = /** @type {(inputs: Infinite_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infinite Scroll`)
};

const es_infinite_scroll = /** @type {(inputs: Infinite_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desplazamiento infinito`)
};

const fr_infinite_scroll = /** @type {(inputs: Infinite_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Défilement infini`)
};

const de_infinite_scroll = /** @type {(inputs: Infinite_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endloses Scrollen`)
};

const ja_infinite_scroll = /** @type {(inputs: Infinite_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無限スクロール`)
};

const zh_infinite_scroll = /** @type {(inputs: Infinite_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无限滚动`)
};

const ar_infinite_scroll = /** @type {(inputs: Infinite_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تمرير لا نهائي`)
};

const id_infinite_scroll = /** @type {(inputs: Infinite_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gulir Tak Terbatas`)
};

const it_infinite_scroll = /** @type {(inputs: Infinite_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scorrimento Infinito`)
};

const ru_infinite_scroll = /** @type {(inputs: Infinite_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бесконечная прокрутка`)
};

const pt_infinite_scroll = /** @type {(inputs: Infinite_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rolagem Infinita`)
};

const ko_infinite_scroll = /** @type {(inputs: Infinite_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무한 스크롤`)
};

/**
* | output |
* | --- |
* | "Infinite Scroll" |
*
* @param {Infinite_ScrollInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const infinite_scroll = /** @type {((inputs?: Infinite_ScrollInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Infinite_ScrollInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_infinite_scroll(inputs)
	if (locale === "es") return es_infinite_scroll(inputs)
	if (locale === "fr") return fr_infinite_scroll(inputs)
	if (locale === "de") return de_infinite_scroll(inputs)
	if (locale === "ja") return ja_infinite_scroll(inputs)
	if (locale === "zh") return zh_infinite_scroll(inputs)
	if (locale === "ar") return ar_infinite_scroll(inputs)
	if (locale === "id") return id_infinite_scroll(inputs)
	if (locale === "it") return it_infinite_scroll(inputs)
	if (locale === "ru") return ru_infinite_scroll(inputs)
	if (locale === "pt") return pt_infinite_scroll(inputs)
	return ko_infinite_scroll(inputs)
});